import { getGuideMediaAsset } from "./guideMediaManifest";
import { resolveGuideAssetUrl } from "./resolveGuideAssetUrl";

function normalizeRelativeAssetPath(relativeAssetPath) {
  if (typeof relativeAssetPath !== "string") {
    return null;
  }

  const trimmed = relativeAssetPath.trim().replace(/\\/g, "/");
  if (!trimmed) {
    return null;
  }

  return trimmed.replace(/^\/?assets\/?/i, "");
}

export function buildPlannedGuideAssetPath(relativeAssetPath) {
  const normalizedRelativePath = normalizeRelativeAssetPath(relativeAssetPath);
  return normalizedRelativePath ? `/assets/${normalizedRelativePath}` : null;
}

export function createPlannedGuideMedia(type, relativeAssetPath, options = {}) {
  const plannedAssetPath = buildPlannedGuideAssetPath(relativeAssetPath);

  return {
    label: options.label || "Overview",
    type,
    status: "planned",
    plannedAssetPath,
    props: options.props || {},
  };
}

export function plannedGuideImage(relativeAssetPath, options = {}) {
  return createPlannedGuideMedia("image", relativeAssetPath, options);
}

export function plannedGuideVideo(relativeAssetPath, options = {}) {
  return createPlannedGuideMedia("video", relativeAssetPath, options);
}

export function isPlannedGuideMedia(entry) {
  return !!entry && entry.status === "planned";
}

export function resolveGuideMediaEntry(entry) {
  if (!isPlannedGuideMedia(entry)) {
    return entry;
  }

  const plannedAssetPath =
    typeof entry?.plannedAssetPath === "string" ? entry.plannedAssetPath : null;
  if (!plannedAssetPath) {
    return entry;
  }

  const publishedAsset = getGuideMediaAsset(plannedAssetPath);
  if (typeof publishedAsset?.remoteUrl !== "string" || !publishedAsset.remoteUrl) {
    return entry;
  }

  return {
    ...entry,
    status: "published",
    src: publishedAsset.remoteUrl,
    storagePath: publishedAsset.storagePath || null,
    remoteUrl: publishedAsset.remoteUrl,
    cacheControl: publishedAsset.cacheControl || null,
    mimeType: publishedAsset.mimeType || null,
  };
}

export function getGuideMediaPreloadSrc(entry) {
  if (!entry || entry.type !== "video" || isPlannedGuideMedia(entry)) {
    return null;
  }

  return typeof entry.src === "string" ? resolveGuideAssetUrl(entry.src) : null;
}
